import { useMutation, useQuery } from '@tanstack/react-query'
import { apiClient, getSessionTokenHeaders } from '../client'
import type { EnrollmentDocument } from '../types/enrollment'
import { BASE_URL } from './shared'
import type { UploadEnrollmentDocumentRequest } from './types'

export const uploadEnrollmentDocumentRequest = async ({
  sessionToken,
  documentType,
  file,
  documentNumber,
  issuingState,
  expiryDate,
  notes
}: UploadEnrollmentDocumentRequest) => {
  const formData = new FormData()
  formData.append('file', file)

  const response = await apiClient.post<EnrollmentDocument>(
    `${BASE_URL}/session/${sessionToken}/documents/${documentType}`,
    formData,
    {
      params: {
        documentNumber,
        issuingState,
        expiryDate,
        notes
      },
      headers: {
        'Content-Type': 'multipart/form-data',
        ...getSessionTokenHeaders(sessionToken)
      }
    }
  )

  return response.data
}

export const listEnrollmentDocumentsRequest = async (sessionToken: string) => {
  const response = await apiClient.get<EnrollmentDocument[]>(
    `${BASE_URL}/session/${encodeURIComponent(sessionToken)}/documents`,
    {
      headers: getSessionTokenHeaders(sessionToken)
    }
  )
  return response.data
}

export const useUploadEnrollmentDocument = () => {
  return useMutation({
    mutationFn: uploadEnrollmentDocumentRequest
  })
}

export const useEnrollmentDocuments = (sessionToken: string | null | undefined) => {
  return useQuery({
    queryKey: ['enrollment', 'documents', sessionToken],
    queryFn: () => listEnrollmentDocumentsRequest(sessionToken!),
    enabled: !!sessionToken
  })
}
